var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.419v2.58h6a1 1 0 0 1 1 1.001v12a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h6V6.416l-1.13 1.129a.993.993 0 0 1-1.407-.007 1 1 0 0 1-.007-1.407l2.842-2.841a.988.988 0 0 1 .697-.29l.008.004c.254 0 .506.095.696.286L17.04 6.13a1 1 0 0 1-1.414 1.414L14.5 6.419zM12.5 11V9h-4a1 1 0 0 1 0 2h4zm2 0h5V9h-5v2zm-2 0h-5v10h12V11h-5v5.002a1 1 0 0 1-2 0V11zm7 0h-1a1 1 0 0 1 0-2h1v2z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.0ab064d6.svg";
export { ForwardRef as ReactComponent };